import React, { Component } from 'react';
import { Section } from 'bulma-react'
import BlogHeader from './BlogHeader';
import BlogContent from './BlogContent';

class BlogSummary extends Component {
  render() {
    const { opened, user, blog, onEdit, loadMore } = this.props;
    return (
      <Section blogSummary style={{
        padding: '0',
        backgroundColor: 'transparent',
        textAlign: 'left',
        margin: '0.5rem 0 1rem',
      }}>
        <BlogHeader blog={blog} user={user} onClick={loadMore} />
        <BlogContent blog={blog} summary opened={opened}
        loadMore={loadMore} onEdit={onEdit}/>
      </Section>
    );
  }
}

export default BlogSummary;




// WEBPACK FOOTER //
// ./src/components/BlogSummary.js